import {
  ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme
} from '@mui/material'
import { palette } from '@theme/core/palette/palette'

export type MuiDividerType = {
  defaultProps?: ComponentsProps['MuiDivider'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDivider'];
  variants?: ComponentsVariants['MuiDivider'];
}

export const MuiDivider:MuiDividerType = {
  styleOverrides: {
    root: {
      borderWidth: '1px',
      borderColor: palette.grey?.['900']
    },
    light: {
      borderColor: palette.grey?.['300']
    },
    vertical: {
      height: '100%'
    }
  }
}
